import { PageDoesntExist } from "@/pageDoesntExist";
import ChallengesPage from "@/pages/Challenges/ChallengesPage";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "../siteRoutesList";
import { SingleChallengePageRenderLogic } from "@/features/challenge/pages/SingleChallengePageRenderLogic";
import { CreateChallengePage, SubmitScore } from "@/features/challenge";
import CounterStrikeChallenge from "@/pages/CounterStrikeChallenge/CounterStrikeChallenge";
import FallGuysChallenge from "@/pages/FallGuysChallenge/FallGuysChallenge";
import ForzaMotorsportChallenge from "@/pages/ForzaMotorsportChallenge/ForzaMotorsportChallenge";
import GameTrackerPage from "@/pages/GameTracker/GameTrackerPage";
import LEGOChallenge from "@/pages/LEGOChallenge/LEGOChallenge";
import TCLTimeTrial from "@/pages/TCL/CounterStrikeChallenge";
import F1Challenge from "@/pages/Challenges/F1Challenge";

export const challengeRoutes = [
  // * Challenges
  {
    element: !brand.hasFeature.challenges ? PageDoesntExist : ChallengesPage,
    path: siteRoutes["challenges"],
  },
  {
    element: !brand.hasFeature.singleChallenge
      ? PageDoesntExist
      : SingleChallengePageRenderLogic,
    path: `${siteRoutes["challengesAndSlug"]}:slug`,
  },
  // * Creating and managing challenges
  {
    element:
      brand.hasCreate.challenges && brand.hasFeature.challenges
        ? CreateChallengePage
        : PageDoesntExist,
    path: siteRoutes["createChallenge"],
  },
  // * Manually submitting scores for challenges
  {
    element:
      !brand.hasFeature.manualSubmissions || !brand.hasFeature.challenges
        ? PageDoesntExist
        : SubmitScore,
    path: `${siteRoutes["submitScoreAndSlug"]}:slug`,
  },
  /* Game Tracker */
  {
    element: brand.hasFeature.challenges ? GameTrackerPage : PageDoesntExist,
    path: siteRoutes["gametracker"],
  },
  /* Direct Linking to active challenge */
  {
    element: brand.hasFeature.challenges ? FallGuysChallenge : PageDoesntExist,
    path: siteRoutes["fallguys"],
  },
  {
    element: brand.hasFeature.challenges
      ? ForzaMotorsportChallenge
      : PageDoesntExist,
    path: siteRoutes["forzamotorsport"],
  },
  {
    element: brand.hasFeature.challenges
      ? CounterStrikeChallenge
      : PageDoesntExist,
    path: siteRoutes["counterstrike"],
  },
  {
    element: brand.hasFeature.challenges ? F1Challenge : PageDoesntExist,
    path: siteRoutes["f1"],
  },
  {
    element: brand.hasFeature.challenges ? TCLTimeTrial : PageDoesntExist,
    path: siteRoutes["TimeTrial"],
  },
];
